// dispatchAccessor.ts

import { AppDispatch } from './types';

let dispatch: AppDispatch | undefined;

export const setDispatch = (d: AppDispatch): void => {
	dispatch = d;
};

export const getDispatch = (): AppDispatch => {
	if (!dispatch) {
		throw new Error('dispatch not set. Call setDispatch(store.dispatch) at app start.');
	}

	return dispatch;
};
